import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Button, Grid } from "@mui/material";
import { callAPI } from "../../../../../App/Helpers/callApi";
import Signifier from "../../../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../../../App/State/Slices/SelectedCareersClientSlice";
import DraggableTable from "../../../../../App/Components/Table/DraggableTable";
import { basicSort } from "../../../../../App/Helpers/BasicSort";
import DropdownComponent from "../../../../../App/Components/Dropdown/DropdownComponent";
import { editResultTable, getResultTable } from "../../../ResultsTableService";
import ResultsTableTableCell from "./ResultsTableTableCell";
import { CheckRoleForClient } from "../../../../../App/Helpers/PermissionsChecks";
import { Roles } from "../../../../../App/Enums/Roles";
import { selectUserPermissionsValue } from "../../../../../App/State/Slices/UserPermissionsSlice";

function ResultsTablePage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "80%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    error: {
      color: theme.palette.error.main,
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const rolesObject = useSelector(selectUserPermissionsValue);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");

  const columns = [
    { label: "Selected", propName: "selected" },
    { label: "Label", propName: "columnAdminText" },
    { label: "Display Name", propName: "" },
    { label: "Sortable", propName: "sortable" },
    { label: "", propName: "" },
  ];

  const getData = () => {
    setLoading(true);
    getResultTable(selectCareersClient.id).then((response) => {
      setTemplates(response.templates);
      response.properties.sort((a, b) => {
        const order = basicSort(
          a.clientAdTableConfigurations[0]?.order,
          b.clientAdTableConfigurations[0]?.order
        );
        if (order !== 0) return order;
        return a[1] - b[1];
      });
      response.properties.forEach((row) => {
        row.selected = row.clientAdTableConfigurations?.length > 0;
        row.display =
          row.clientAdTableConfigurations[0]?.columnDisplayName === undefined
            ? ""
            : row.clientAdTableConfigurations[0]?.columnDisplayName;
        row.isSortable =
          row.clientAdTableConfigurations[0]?.isSortable === undefined
            ? false
            : row.clientAdTableConfigurations[0]?.isSortable;
      });
      setTableData(response.properties);
      setLoading(false);
    });
  };

  function saveResultsTable() {
    var addProperties = [];
    var newOrder = 1;
    tableData.forEach((row) => {
      if (row.selected && row.display !== "") {
        let newProperty = {
          AvailableAdTableColumnId: row.id,
          ClientId: selectCareersClient.id,
          ColumnDisplayName: row.display,
          IsSortable: row.isSortable,
          Order: newOrder,
        };
        newOrder += 1;
        addProperties.push(newProperty);
      }
    });

    let data = {
      ClientId: selectCareersClient.id,
      selectedProperties: addProperties,
      templateId: selectedTemplate.id,
    };

    callAPI(
      editResultTable(selectCareersClient.id, data),
      "Result Table Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getData();
    });
  }

  useEffect(() => {
    if (selectCareersClient !== null) {
      getData();
    }
  }, [selectCareersClient]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12}>
            <Button
              sx={{
                marginBottom: "10px",
                marginRight: "20px",
              }}
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => saveResultsTable()}
            >
              Save
            </Button>
          </Grid>
          {CheckRoleForClient(
            rolesObject,
            selectCareersClient.id?.toUpperCase(),
            Roles.SuperAdmin
          ) ? (
            <Grid item xs={12} sm={3}>
              <DropdownComponent
                currValue={selectedTemplate}
                items={templates}
                property="name"
                title="Assign To Template"
                handleChange={(value) => setSelectedTemplate(value)}
              />
            </Grid>
          ) : null}
          <DraggableTable
            columns={columns}
            tableData={tableData}
            setTableData={setTableData}
            rowComponent={ResultsTableTableCell}
            loading={loading}
          />
        </Grid>
      </div>
    </>
  );
}

export default ResultsTablePage;
